import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "header" };
const _hoisted_2 = { class: "header-left" };
const _hoisted_3 = { class: "header-right" };
const _hoisted_4 = { class: "user-info" };
const _hoisted_5 = { class: "user-name" };
const _hoisted_6 = { class: "dialog-footer" };
const _hoisted_7 = { class: "dialog-footer" };
import { ref, computed, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { ElMessageBox } from 'element-plus';
import { User, ArrowDown, Lock, SwitchButton } from '@element-plus/icons-vue';
import { useUserStore } from '@/stores/user';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Header',
    setup(__props) {
        const route = useRoute();
        const router = useRouter();
        const userStore = useUserStore();
        // 表单引用
        const profileFormRef = ref();
        const passwordFormRef = ref();
        // 对话框显示状态
        const showProfileDialog = ref(false);
        const showPasswordDialog = ref(false);
        // 加载状态
        const profileLoading = ref(false);
        const passwordLoading = ref(false);
        // 个人设置表单
        const profileForm = ref({
            realName: '',
            email: '',
            phone: '',
            avatar: ''
        });
        // 修改密码表单
        const passwordForm = ref({
            oldPassword: '',
            newPassword: '',
            confirmPassword: ''
        });
        // 表单验证规则
        const profileRules = {
            email: [
                { type: 'email', message: '请输入正确的邮箱格式', trigger: 'blur' }
            ],
            phone: [
                { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
            ]
        };
        const passwordRules = {
            oldPassword: [
                { required: true, message: '请输入原密码', trigger: 'blur' }
            ],
            newPassword: [
                { required: true, message: '请输入新密码', trigger: 'blur' },
                { min: 6, message: '密码长度不能少于6位', trigger: 'blur' }
            ],
            confirmPassword: [
                { required: true, message: '请再次输入新密码', trigger: 'blur' },
                {
                    validator: (rule, value, callback) => {
                        if (value !== passwordForm.value.newPassword) {
                            callback(new Error('两次输入的密码不一致'));
                        }
                        else {
                            callback();
                        }
                    },
                    trigger: 'blur'
                }
            ]
        };
        const pageTitle = computed(() => {
            return route.meta?.title || '管理系统';
        });
        // 处理下拉菜单命令
        const handleCommand = (command) => {
            switch (command) {
                case 'profile':
                    showProfileDialog.value = true;
                    break;
                case 'password':
                    showPasswordDialog.value = true;
                    break;
                case 'logout':
                    handleLogout();
                    break;
            }
        };
        // 处理登出
        const handleLogout = async () => {
            try {
                await ElMessageBox.confirm('确定要退出登录吗？', '确认退出', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                });
                await userStore.logout();
                router.push('/login');
            }
            catch (error) {
                // 用户取消登出
            }
        };
        // 处理更新个人信息
        const handleUpdateProfile = async () => {
            if (!profileFormRef.value)
                return;
            try {
                await profileFormRef.value.validate();
                profileLoading.value = true;
                const success = await userStore.updateProfile(profileForm.value);
                if (success) {
                    showProfileDialog.value = false;
                }
            }
            catch (error) {
                console.error('Profile validation failed:', error);
            }
            finally {
                profileLoading.value = false;
            }
        };
        // 处理修改密码
        const handleChangePassword = async () => {
            if (!passwordFormRef.value)
                return;
            try {
                await passwordFormRef.value.validate();
                passwordLoading.value = true;
                const success = await userStore.changePassword({
                    oldPassword: passwordForm.value.oldPassword,
                    newPassword: passwordForm.value.newPassword
                });
                if (success) {
                    showPasswordDialog.value = false;
                    resetPasswordForm();
                }
            }
            catch (error) {
                console.error('Password validation failed:', error);
            }
            finally {
                passwordLoading.value = false;
            }
        };
        // 重置个人设置表单
        const resetProfileForm = () => {
            if (userStore.userInfo) {
                profileForm.value = {
                    realName: userStore.userInfo.realName || '',
                    email: userStore.userInfo.email || '',
                    phone: userStore.userInfo.phone || '',
                    avatar: userStore.userInfo.avatar || ''
                };
            }
            profileFormRef.value?.resetFields();
        };
        // 重置密码表单
        const resetPasswordForm = () => {
            passwordForm.value = {
                oldPassword: '',
                newPassword: '',
                confirmPassword: ''
            };
            passwordFormRef.value?.resetFields();
        };
        // 监听用户信息变化，初始化表单
        watch(() => userStore.userInfo, (newUserInfo) => {
            if (newUserInfo) {
                resetProfileForm();
            }
        }, { immediate: true });
        return (_ctx, _cache) => {
            const _component_el_avatar = _resolveComponent("el-avatar");
            const _component_el_icon = _resolveComponent("el-icon");
            const _component_el_tag = _resolveComponent("el-tag");
            const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
            const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
            const _component_el_dropdown = _resolveComponent("el-dropdown");
            const _component_el_input = _resolveComponent("el-input");
            const _component_el_form_item = _resolveComponent("el-form-item");
            const _component_el_form = _resolveComponent("el-form");
            const _component_el_button = _resolveComponent("el-button");
            const _component_el_dialog = _resolveComponent("el-dialog");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("h3", null, _toDisplayString(pageTitle.value), 1)
                    ]),
                    _createElementVNode("div", _hoisted_3, [
                        _createVNode(_component_el_dropdown, { onCommand: handleCommand }, {
                            dropdown: _withCtx(() => [
                                _createVNode(_component_el_dropdown_menu, null, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_el_dropdown_item, { command: "profile" }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_el_icon, null, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_unref(User))
                                                    ]),
                                                    _: 1
                                                }),
                                                _cache[13] || (_cache[13] = _createTextVNode(" 个人设置 "))
                                            ]),
                                            _: 1,
                                            __: [13]
                                        }),
                                        _createVNode(_component_el_dropdown_item, { command: "password" }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_el_icon, null, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_unref(Lock))
                                                    ]),
                                                    _: 1
                                                }),
                                                _cache[14] || (_cache[14] = _createTextVNode(" 修改密码 "))
                                            ]),
                                            _: 1,
                                            __: [14]
                                        }),
                                        _createVNode(_component_el_dropdown_item, {
                                            command: "logout",
                                            divided: ""
                                        }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_el_icon, null, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_unref(SwitchButton))
                                                    ]),
                                                    _: 1
                                                }),
                                                _cache[15] || (_cache[15] = _createTextVNode(" 退出登录 "))
                                            ]),
                                            _: 1,
                                            __: [15]
                                        })
                                    ]),
                                    _: 1
                                })
                            ]),
                            default: _withCtx(() => [
                                _createElementVNode("span", _hoisted_4, [
                                    (_unref(userStore).userAvatar)
                                        ? (_openBlock(), _createBlock(_component_el_avatar, {
                                            key: 0,
                                            src: _unref(userStore).userAvatar,
                                            size: 32
                                        }, null, 8, ["src"]))
                                        : (_openBlock(), _createBlock(_component_el_icon, { key: 1 }, {
                                            default: _withCtx(() => [
                                                _createVNode(_unref(User))
                                            ]),
                                            _: 1
                                        })),
                                    _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(userStore).userName || _unref(userStore).userInfo?.username), 1),
                                    (_unref(userStore).isAdmin)
                                        ? (_openBlock(), _createBlock(_component_el_tag, {
                                            key: 2,
                                            type: "danger",
                                            size: "small"
                                        }, {
                                            default: _withCtx(() => _cache[11] || (_cache[11] = [
                                                _createTextVNode("管理员")
                                            ])),
                                            _: 1,
                                            __: [11]
                                        }))
                                        : (_unref(userStore).isManager)
                                            ? (_openBlock(), _createBlock(_component_el_tag, {
                                                key: 3,
                                                type: "warning",
                                                size: "small"
                                            }, {
                                                default: _withCtx(() => _cache[12] || (_cache[12] = [
                                                    _createTextVNode("管理员")
                                                ])),
                                                _: 1,
                                                __: [12]
                                            }))
                                            : _createCommentVNode("", true),
                                    _createVNode(_component_el_icon, null, {
                                        default: _withCtx(() => [
                                            _createVNode(_unref(ArrowDown))
                                        ]),
                                        _: 1
                                    })
                                ])
                            ]),
                            _: 1
                        })
                    ])
                ]),
                _createVNode(_component_el_dialog, {
                    modelValue: showProfileDialog.value,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((showProfileDialog).value = $event)),
                    title: "个人设置",
                    width: "500px",
                    onClose: resetProfileForm
                }, {
                    footer: _withCtx(() => [
                        _createElementVNode("div", _hoisted_6, [
                            _createVNode(_component_el_button, {
                                onClick: _cache[4] || (_cache[4] = ($event) => (showProfileDialog.value = false))
                            }, {
                                default: _withCtx(() => _cache[16] || (_cache[16] = [
                                    _createTextVNode("取消")
                                ])),
                                _: 1,
                                __: [16]
                            }),
                            _createVNode(_component_el_button, {
                                type: "primary",
                                onClick: handleUpdateProfile,
                                loading: profileLoading.value
                            }, {
                                default: _withCtx(() => _cache[17] || (_cache[17] = [
                                    _createTextVNode(" 保存 ")
                                ])),
                                _: 1,
                                __: [17]
                            }, 8, ["loading"])
                        ])
                    ]),
                    default: _withCtx(() => [
                        _createVNode(_component_el_form, {
                            ref_key: "profileFormRef",
                            ref: profileFormRef,
                            model: profileForm.value,
                            rules: profileRules,
                            "label-width": "80px"
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_el_form_item, { label: "用户名" }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                            value: _unref(userStore).userInfo?.username,
                                            disabled: ""
                                        }, null, 8, ["value"])
                                    ]),
                                    _: 1
                                }),
                                _createVNode(_component_el_form_item, {
                                    label: "真实姓名",
                                    prop: "realName"
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                            modelValue: profileForm.value.realName,
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((profileForm.value.realName) = $event)),
                                            placeholder: "请输入真实姓名"
                                        }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                }),
                                _createVNode(_component_el_form_item, {
                                    label: "邮箱",
                                    prop: "email"
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                            modelValue: profileForm.value.email,
                                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((profileForm.value.email) = $event)),
                                            placeholder: "请输入邮箱"
                                        }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                }),
                                _createVNode(_component_el_form_item, {
                                    label: "手机号",
                                    prop: "phone"
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                            modelValue: profileForm.value.phone,
                                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((profileForm.value.phone) = $event)),
                                            placeholder: "请输入手机号"
                                        }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                }),
                                _createVNode(_component_el_form_item, {
                                    label: "头像",
                                    prop: "avatar"
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                            modelValue: profileForm.value.avatar,
                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((profileForm.value.avatar) = $event)),
                                            placeholder: "请输入头像URL"
                                        }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                })
                            ]),
                            _: 1
                        }, 8, ["model"])
                    ]),
                    _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_el_dialog, {
                    modelValue: showPasswordDialog.value,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((showPasswordDialog).value = $event)),
                    title: "修改密码",
                    width: "400px",
                    onClose: resetPasswordForm
                }, {
                    footer: _withCtx(() => [
                        _createElementVNode("div", _hoisted_7, [
                            _createVNode(_component_el_button, {
                                onClick: _cache[9] || (_cache[9] = ($event) => (showPasswordDialog.value = false))
                            }, {
                                default: _withCtx(() => _cache[18] || (_cache[18] = [
                                    _createTextVNode("取消")
                                ])),
                                _: 1,
                                __: [18]
                            }),
                            _createVNode(_component_el_button, {
                                type: "primary",
                                onClick: handleChangePassword,
                                loading: passwordLoading.value
                            }, {
                                default: _withCtx(() => _cache[19] || (_cache[19] = [
                                    _createTextVNode(" 确认修改 ")
                                ])),
                                _: 1,
                                __: [19]
                            }, 8, ["loading"])
                        ])
                    ]),
                    default: _withCtx(() => [
                        _createVNode(_component_el_form, {
                            ref_key: "passwordFormRef",
                            ref: passwordFormRef,
                            model: passwordForm.value,
                            rules: passwordRules,
                            "label-width": "80px"
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_el_form_item, {
                                    label: "原密码",
                                    prop: "oldPassword"
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                            modelValue: passwordForm.value.oldPassword,
                                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((passwordForm.value.oldPassword) = $event)),
                                            type: "password",
                                            placeholder: "请输入原密码",
                                            "show-password": ""
                                        }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                }),
                                _createVNode(_component_el_form_item, {
                                    label: "新密码",
                                    prop: "newPassword"
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                            modelValue: passwordForm.value.newPassword,
                                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((passwordForm.value.newPassword) = $event)),
                                            type: "password",
                                            placeholder: "请输入新密码",
                                            "show-password": ""
                                        }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                }),
                                _createVNode(_component_el_form_item, {
                                    label: "确认密码",
                                    prop: "confirmPassword"
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                            modelValue: passwordForm.value.confirmPassword,
                                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((passwordForm.value.confirmPassword) = $event)),
                                            type: "password",
                                            placeholder: "请再次输入新密码",
                                            "show-password": ""
                                        }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                })
                            ]),
                            _: 1
                        }, 8, ["model"])
                    ]),
                    _: 1
                }, 8, ["modelValue"])
            ], 64));
        };
    }
});
